import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/style/reset.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/font.css'
import './assets/style/common.css'
import store from './store'
import scroll from 'vue-seamless-scroll'
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(scroll)

new Vue({
  router,
  render: h => h(App),
  store
}).$mount('#app')
